const userRoute = [
  {
    path: '/user/user-list',
    name: 'USERlist',
    authed: 'USERlist',
    component: () => import('@/views/user/USERlist/index.vue'),
    meta: {
      tabName: 'User List',
      title: 'User List',
      group: 'User Mgmt.',
      icon: 'mdiAccountCircle',
      groupSort: 10,
    },
  },
  {
    path: '/user/user-list/user-detail',
    name: 'USERDetail',
    authed: 'USERDetail',
    component: () => import('@/views/user/USERlist/USERDetail/index.vue'),
    meta: {
      tabName: 'USER DETAIL',
      group: 'User Mgmt.',
      isHide: true,
    },
  },
  {
    path: '/user/dummy-user',
    name: 'DUMMYUser',
    authed: 'DUMMYUser',
    component: () => import('@/views/user/DUMMYUser/index.vue'),
    meta: {
      tabName: 'OEM Account',
      group: 'User Mgmt.',
      title: 'OEM Account',
    },
  },

  {
    path: '/user/dummy-user/dummy-detail',
    name: 'DUMMYDetail',
    authed: 'DUMMYDetail',
    component: () => import('@/views/user/DUMMYUser/DUMMYDetail/index.vue'),
    meta: {
      tabName: 'USER DETAIL',
      group: 'User Mgmt.',
      isHide: true,
    },
  },
]

export default userRoute
